import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';

import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import {
  findSharedEntityByEntity,
  validateLink,
} from '../../../modules/shared-entities/repository/shared-entities.repository';
import {
  FindSharedEntityByEntityParams,
  IGetSharedEntityResponse,
} from '../../../modules/shared-entities/types/sharedEntities.types';
import { getFindSharedEntitiesKey, getFindSharedEntityByEntityKey } from './sharedEntities.keys';
import { FindSharedEntityParams } from './sharedEntities.types';

export const useFindSharedEntity = (
  params: FindSharedEntityParams,
  options?: UseDataQueryOptions,
) =>
  useDataQuery<IGetSharedEntityResponse | null>(
    {
      staleTime: 10000,
      queryKey: getFindSharedEntitiesKey(params),
      queryFn: async () => {
        if (!params.id) {
          return null;
        }
        const data = await validateLink(params.id);
        if (!data.ok || !data.data) {
          return null;
        }
        return data.data;
      },
    },
    options,
  );

export const useFindSharedEntityByEntity = (
  params: FindSharedEntityByEntityParams,
  options?: UseDataQueryOptions,
) =>
  useDataQuery<boolean>(
    {
      queryKey: getFindSharedEntityByEntityKey(params),
      queryFn: async () => {
        if (!params.entityId) {
          return false;
        }
        const data = await findSharedEntityByEntity({
          entity: params.entity,
          entityId: params.entityId,
        });
        return !!data.ok && !!data.data;
      },
    },
    options,
  );
